<template>
  <main>
    <div v-if="shippingMethod == 'door-to-door'" class="px-2">
      <div class="flex items-center justify-between pb-3 px-3 mt-5">
        <div>
          <p class="font-bold">Request Details</p>
          <p>
            <span class="font-semibold">Shipping Reference:</span>
            {{ shipping.shippingReference }}
          </p>
          <p>
            <span class="font-semibold">Package: </span>
            {{ shipping.consigneelocation ? fullRecieverAddress : "N/A" }}
          </p>
        </div>
        <div class="text-primary-yellow">
          {{ shipping.shippingReference ? shipping.shippingReference : "N/A" }}
        </div>
      </div>

      <div
        v-if="stillSearching"
        class="shadow-md bg-gray-100 mt-4 rounded-lg"
        :style="{ height: '290px' }"
      >
        <div class="pt-20">
          <div class="w-full flex justify-center">
            <span class="loader"> <img src="@/assets/images/ondemand/loader.svg" /></span>
          </div>

          <p
            :style="{ color: '#09B78A', width: '220px' }"
            class="mx-auto mt-3 text-center"
          >
            Searching for a dispatcher. Please be patient.
          </p>
        </div>
      </div>

      <div v-if="!stillSearching" class="px-3 mt-3">
        <gmap-map
          :center="center[0]"
          @place_changed="setPlace"
          :zoom="12"
          style="width: 100%; height: 400px"
        >
          <directions-renderer
            travelMode="DRIVING"
            :origin="center[0]"
            :destination="center[1]"
          />
        </gmap-map>
      </div>

      <div class="px-3 mt-5 pb-10">
        <div v-if="!stillSearching" class="shadow-md bg-gray-100 mt-4 rounded p-3">
          <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
            <div class="flex pb-2 items-center">
              <span class="block w-6/12 text-gray-500">Description</span>
              <span class="w-6/12 flex items-center justify-end"
                >{{  totalpackageDiscription  }}
                <button
                  @click="isMinimize = !isMinimize"
                  class="text-primary-yellow text-3xl ml-2"
                >
                  {{ isMinimize ? "&minus;" : "&plus;" }}
                </button>
              </span>
            </div>
            <div class="flex pb-2" v-if="isMinimize">
              <span class="block w-6/12 text-gray-500">Receiver</span>
              <span class="block w-6/12 text-right"
                >{{
                  shipping.consigneelocation
                    ? shipping.consigneelocation.contactName ||
                      shipping.consigneelocation.contactPerson
                    : "N/A"
                }}
                ({{
                  shipping.consigneelocation ? shipping.consigneelocation.mobile : "N/A"
                }})</span
              >
            </div>
            <div class="flex pb-2" v-if="isMinimize">
              <span class="block w-6/12 text-gray-500">Sender</span>
              <span class="block w-6/12 text-right"
                >{{
                  shipping.shipperlocation ? shipping.shipperlocation.contactName : "N/A"
                }}
                ({{
                  shipping.shipperlocation ? shipping.shipperlocation.mobile : "N/A"
                }})</span
              >
            </div>
          </div>

          <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
            <div class="flex pb-2" v-if="liveTripData.status == 'accepted'">
              <span class="block w-6/12 text-gray-500">Pick-Up Time</span>
              <span class="block w-6/12 text-right"
                >{{
                  liveTripData.origin
                    ? changeTimeFormat(liveTripData.origin.departure_time)
                    : "N/A"
                }}
              </span>
            </div>
            <div class="flex pb-2" v-if="liveTripData.status == 'in-transit'" >
              <span class="block w-6/12 text-gray-500"
                >Estimated Delivery time</span
              >
              <span class="block w-6/12 text-right"
                >{{ tripsDetails.duration ? tripsDetails.duration.text : "---" }}
              </span>
            </div>
            <div class="flex pb-2">
              <span class="block w-6/12 text-gray-500">Payment</span>
              <span class="block w-6/12 text-right">{{
                shipping.transaction ? shipping.transaction.paymentStatus : "N/A"
              }}</span>
            </div>
          </div>

          <div class="mt-2 border-b-2 pb-1 border-dashed border-gray-300">
            <div class="flex pb-2">
              <span class="block w-6/12 text-gray-500">{{ Dispatcher }}</span>
              <span class="block w-6/12 text-right"
                >{{ liveTripData ? liveTripData.firstname : "" }}
                {{ liveTripData ? liveTripData.lastname : "" }}</span
              >
            </div>
            <div class="flex pb-2">
              <span class="block w-6/12 text-gray-500">Mobile No.</span>
              <span class="block w-6/12 text-right"
                >{{ liveTripData ? liveTripData.mobile_no : "" }}</span
              >
            </div>
            <div class="flex pb-2">
              <span class="block w-6/12 text-gray-500">Fleet</span>
              <span class="block w-6/12 text-right">{{
                  liveTripData.fleet ? liveTripData.fleet.vehicleType : "N/A"
                }} | {{  liveTripData.fleet ? liveTripData.fleet.vehicleNumber : "N/A" }}
              </span>
            </div>
            <div class="flex pb-2">
              <span class="block w-6/12 text-gray-500">Status</span>
              <span class="block w-6/12 text-right text-primary-yellow capitalize">{{
                liveTripData.status || tripAccepted.status
                  ? liveTripData.status || tripAccepted.status
                  : "N/A"
              }}</span>
            </div>
          </div>
        </div>

        <div class="mt-5 flex justify-between">
          <button @click="routeToActiveBooking">Close</button>
        </div>

        <div hidden class="flex justify-between">
          <div v-if="stillSearching" class="mt-5 flex justify-between">
            <button @click="$emit('close-modal')">Cancel Booking</button>
          </div>

          <div v-if="!stillSearching" class="mt-5 flex justify-between">
            <button @click="$emit('close-modal')">Message</button>
          </div>

          <div v-if="!stillSearching" class="mt-5 flex justify-between">
            <base-button text="Cancel Booking" @click="$emit('close-modal')" />
          </div>
        </div>
      </div>
    </div>

    <SuccessShipping
      v-if="shippingMethod != 'door-to-door'"
      :showModal="showCancleBookingModal"
      @close-modal="closeModal()"
      :endRoute="endRoute"
    />
  </main>
</template>

<script>
import DirectionsRenderer from "@/components/3pl/Operations/Bookings/NewBooking/Modals/DirectionsRenderer";
import SuccessShipping from "./Modals/SuccessShippment.vue";
import moment from "moment";

export default {
  components: {
    DirectionsRenderer,
    SuccessShipping,
  },
  data() {
    return {
      loading: false,
      isMinimize: true,
      shipping: {},
      endRoute: "",
      showCancleBookingModal: false,
      shippingMethod: "",
      center: [
        { lat: 43.3, lng: 10.3 },
        { lat: 42.2, lng: 9.7 },
      ],
      origin: {},
      organizations: [],
      stillSearching: false,
      tripData: {},
      dispatcher: {},
      liveTripData: {},
      tripsDetails: {},
      tripId : ""
    };
  },
  watch: {
    "shipping.id"(val) {
      this.sockets.subscribe(val, (data) => {
        if (data.shippingId !== this.shipping.id) return;

        console.log(data, "From ShippingId")
        let response = {}
        response.status = data.status
        response.fleet = {
          vehicleModel: data?.vehicleType
        }
        response.origin = {
          departure_time: data?.estimatedDeliveryDate
        }

        this.liveTripData = response;

        this.tripAccepted(data);
      });
    },
    tripId(val){
      this.socketEventName = val;
      console.log(val)
      this.sockets.subscribe(val, (data) => {
        console.log(data, "From TripId")
        this.liveTripData = data;
        this.center = [
          {
            lat: this.shipping.shipperlocation?.address.lat || 0,
            lng: this.shipping.shipperlocation?.address.lng || 0,
          },
          {
            lat: data?.location?.latitude || 0,
            lng: data?.location?.longitude || 0,
          },
        ];
        const payload = {
          origin: {
            lat: this.shipping.shipperlocation?.address.lat || 0,
            long: this.shipping.shipperlocation?.address.lng || 0,
          },
          destination: {
            lat: data?.location.latitude || 0,
            long: data?.location?.longitude || 0,
            departure_time: data?.depature_time || "2023-09-22T09:25:07Z",
          },
        };
        this.getTripDetails(payload);
      });
      
    },

    shipping() {
      console.log("shipping", this.shipping);
    },
  },
  sockets: {
    connect: function () {
      console.log("SOcket has connected for booking direction");
    }
  },
  mounted() {
    this.getShipping();
    this.getOrganizations();
    this.geolocate();
  },
  activated() {
    this.getShipping();
    this.geolocate();
  },
  computed: {
    totalpackageDiscription() {
      if (!this.shipping?.packagees.length) return "";
      return this.shipping?.packagees
        .map((item) => item?.description)
        .reduce((prev, next) => prev + ", " + next);
    },
    shippingId() {
      return this.$store.getters.shippingId;
    },
    getLoadWeight() {
      if (!this.shipping?.packagees.length) return "0";
      const totalLoadWeight = this.shipping?.packagees
        .map((item) => item.estimatedWeight)
        .reduce((prev, next) => prev + next);
      return totalLoadWeight * 1000;
    },
    fullRecieverAddress() {
      return this.extractAddress(this.shipping.consigneelocation.address);
    },
    destination() {
      return {
        lat: this.shipping.consigneelocation?.address.lat
          ? this.shipping.consigneelocation?.address.lat
          : 0,
        lng: this.shipping.consigneelocation?.address.lng
          ? this.shipping.consigneelocation?.address.lng
          : 0,
      };
    },
    Dispatcher(){
      let handler = this.liveTripData?.fleet?.vehicleType?.toLowerCase()
      switch (handler) {
        case 'bike':
          handler = 'Rider of Bike'
          break;
        case 'truck':
          handler = 'Driver of Truck'
          break;
        case 'car':
          handler = 'Driver of Car'
          break;
        default:
          break;
      }
      return handler
    },
  },
  methods: {
    routeToActiveBooking() {
      this.stillSearching = false;
      this.$router.push("/operations/booking");
      this.$store.dispatch("resetState");
    },
    async getTripDetails(payload) {
      try {
        const response = await this.$_getEstimatedLocationTime(payload);
        this.tripsDetails = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    changeTimeFormat(val) {
      return moment(val).format("DD-MM-YYYY, hh:mm") ?? "";
    },
    async getShipping() {
      try {
        const response = await this.$_getShipmentById(this.$store.getters.shippingId);
        this.shipping = response.data.data.shipping;
        // let locationDetails = this.getLocationDetails(this.shipping.dropOff);

        this.endRoute = `${this.shipping.shippingservice?.takeOff?.address} 
        ${this.shipping.shippingservice?.takeOff?.city},
         ${this.shipping.shippingservice?.takeOff?.state} 
         ${this.shipping.shippingservice?.takeOff?.country} (<em style='opacity: 0.5; font-weight:500'>${this.shipping.shippingservice?.orgName}</em>)
         `;

        this.center = [
          {
            lat: this.shipping.shipperlocation?.address.lat || 0,
            lng: this.shipping.shipperlocation?.address.lng || 0,
          },
          {
            lat: this.shipping.consigneelocation?.address.lat || 0,
            lng: this.shipping.consigneelocation?.address.lng || 0,
          },
        ];
        this.shippingMethod = this.shipping?.shippingMethod;

        if (
          this.shippingMethod == "door-to-door"
        ) {
          !this.$store.getters.latestNewBooking.hasSentTrips &&
            (await this.creatTripRequest());
        } else {
          this.showCancleBookingModal = true;
        }
      } catch (error) {
        //
      }
    },
    geolocate: function () {
      this.origin = {
        lat: Number(this.shipping.shipperlocation?.address.lat ?? 0),
        lng: Number(this.shipping.shipperlocation?.address.lng ?? 0),
      };
    },

    closeModal() {
      this.showCancleBookingModal = false;
      this.$router.push("/operations/booking");
      this.$store.dispatch("resetState");
    },
    async tripAccepted(val) {
      // console.log("--------",val, this.canShowMap, this.checkPaymentType, this.stillSearching);
      this.tripData = val;
      this.tripId = val?.id
      try {
        const response = await this.$_getDispatcherDetails(val.userId);
        this.dispatcher = response.data.data.user;
        this.stillSearching = false;
      } catch (error) {
        //...
      } finally {
        this.stillSearching = false;
      }
    },
    async creatTripRequest() {
      this.stillSearching = true;
      await this.$apollo
        .mutate({
          mutation: this.$_GraphQL_Endpoint.getDispatchDriver,
          variables: {
            newTripData: {
              bookingChannel: "muleex",
              bookingDate: this.shipping.createdAt,
              destination: {
                address: this.shipping.consigneelocation
                  ? this.shipping.consigneelocation.address.name
                  : "N/A",
                lat: this.shipping.consigneelocation
                  ? this.shipping.consigneelocation.address.lat
                  : "N/A",
                long: this.shipping.consigneelocation
                  ? this.shipping.consigneelocation.address.lng
                  : "N/A",
                user: {
                  name: this.shipping.consigneelocation
                    ? this.shipping.consigneelocation.contactName ||
                      this.shipping.consigneelocation.consigneelocation.contactPerson
                    : "N/A",
                  phoneNumber: this.shipping.consigneelocation
                    ? this.shipping.consigneelocation.email
                    : "N/A",
                },
              },
              loadWeight: this.getLoadWeight,
              orderDate: new Date(),
              origin: {
                address: this.shipping.shipperlocation
                  ? this.shipping.shipperlocation.address.name
                  : "N/A",
                lat: this.shipping.shipperlocation
                  ? Number(this.shipping.shipperlocation.address.lat)
                  : "N/A",
                long: this.shipping.shipperlocation
                  ? Number(this.shipping.shipperlocation.address.lng)
                  : "N/A",
                user: {
                  name: this.shipping.shipperlocation
                    ? this.shipping.shipperlocation.contactName ||
                      this.shipping.shipperlocation.contactPerson
                    : "N/A",
                  phoneNumber: this.shipping.shipperlocation
                    ? this.shipping.shipperlocation.email
                    : "N/A",
                },
              },
              shippingId: this.shipping.id,
              tripCost: Number(this.shipping?.transaction?.totalValue) || 0,
              status: "pending",
              vehicleType : this.$store.state.bookingModule.newBooking.vehicleType ? this.$store.state.bookingModule.newBooking.vehicleType : "Truck",
              paymentType: this.$store.getters?.getBookingpaymenttype3Pl.toLowerCase()
            },
          },
        })
        .then((res) => {
          if (
            res.data.createTrip.trip.status == "in-transit" ||
            res.data.createTrip.trip.status == "accepted"
          ) {
            this.stillSearching = false;
          }
          if (res.message == "No drivers available") {
            this.generateToast(res.message, "error");
          }
          this.$store.commit("SET_BOOKING_HAS_SET_TRIPS", true);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.loader {
  display: inline-block;
  width: auto;
  height: auto;
  animation: 2s infinite linear rolls;
}
@keyframes rolls {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
